// Libs
import React, { ReactElement } from 'react';
import clsx from 'clsx';
// App
import { Paper, PaperProps } from 'ui-components';
import styles from './content-card.module.scss';

/**
 * Create a white paper container
 * Designed to be used a root of a page, and in conjonction with content-card-title
 * @param props the component props
 */
const ContentCard = (props: PaperProps): ReactElement => {
  const { children, className } = props;

  return (
    <Paper elevation={0} {...props} className={clsx(styles.card, className)}>
      {children}
    </Paper>
  );
};

export default ContentCard;
